import styled from 'styled-components';
import { palette } from 'styled-tools';

import { units } from '@calm-web/design-system';

import { PageWrap } from '../../styles';

export const ErrorPageWrap = styled(PageWrap)<{ backgroundColor?: string }>`
	background: ${({ backgroundColor }) => palette(backgroundColor ?? 'gradientCalmBrandDark')};
	padding-top: 0;
`;

export const Wrapper = styled.div`
	padding: ${units(5)};
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${units(5)};
`;

export const Copy = styled.div`
	text-align: center;
`;
